import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthProviderWrapper";
import InfoRow from "./InfoRow";
import { ButtonLink } from "../../misc/button/Button";
import { Checkbox, Alert, Spin } from "antd";
import axios from "axios";
import { BACKEND_URL } from "../../../config/config";
import { renderCheckboxOrHidden } from "../../helper-function/helperFunction";
import ModalSelectionCompany from "../multiAccount/ModalSelectionCompany";
import SurveyModal from "../../misc/SurveyModal";

const infoAlertContent = (
  <div>
    <h6>
      Nous vous invitons à vérifier l'ensemble des « informations adhérent » et
      à les modifier si elles ne correspondent pas à la situation de votre
      entreprise.
    </h6>
    <p>
      <b>
        Conventions régionales IDF (hors 77) des secteurs Bâtiment et Travaux
        Publics :
      </b>{" "}
      Les conventions régionales IDF (hors 77) des secteurs du Bâtiment et
      Travaux Publics en vigueur prévoient le versement d'une cotisation
      obligatoire déterminée par un pourcentage du montant des salaires payés
      aux salariés déclarés pour les catégories professionnelles concernées. Par
      salaire, on doit comprendre tout ce qui constitue la rémunération du
      travailleur. Pour la (ou les) catégorie(s) professionnelle(s) non visées
      par une quelconque convention, l'Adhérent pourra opter pour le versement
      d'une cotisation volontaire en complément de celle(s) obligatoire(s) pour
      l'autre (ou les) autre(s) catégorie(s) professionnelle(s).
      <br />
      <br />
      <b>Adhésion Volontaire : </b> Les entreprises du Bâtiment situées dans le
      77, celles annexes ou connexes à la profession ainsi que les organismes
      professionnels du BTP peuvent adhérer volontairement à l'Association.
    </p>
  </div>
);

function InfoDetail() {
  const { user, setUser, activeCompany, setUserCompanies } =
    useContext(AuthContext);
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const receivedDataIdentifier = state?.message;
  const [conditionCheckbox, setConditionCheckbox] = useState(false);
  const [showSurveyModal, setShowSurveyModal] = useState(false);

  useEffect(() => {
    const condition = renderCheckboxOrHidden(user, null);
    setConditionCheckbox(condition);
  }, [user]);

  useEffect(() => {
    const getUser = async () => {
      await axios
        .get(`${BACKEND_URL}/api/login/user_info`, {
          withCredentials: true,
        })
        .then((response) => {
          const user = response.data;
          setIsLoading(false);
          setUser(user);
          setUserCompanies(user.companies);
        })
        .catch((error) => {
          console.error("Failed to fetch user info:", error);
        });
    };
    getUser();
  }, []);

  // Survey modal logic
  useEffect(() => {
    // Check if user data is available and user is not admin
    if (user && user.roles && !isLoading) {
      const isAdmin = user.roles.includes('ROLE_ADMIN');
      const surveyShown = sessionStorage.getItem('survey_shown');
      
      // Check if current date is before October 4, 2025 00:00
      const currentDate = new Date();
      const cutoffDate = new Date('2025-10-06T00:00:00');
      const isBeforeCutoff = currentDate < cutoffDate;
      
      // Show modal if user is not admin, popup hasn't been shown this session, and before cutoff date
      if (!isAdmin && !surveyShown && isBeforeCutoff) {
        setShowSurveyModal(true);
        // Set sessionStorage flag when modal is shown
        sessionStorage.setItem('survey_shown', 'true');
      }
    }
  }, [user, isLoading]);

  // Handle modal close
  const handleSurveyModalClose = () => {
    setShowSurveyModal(false);
  };

  return (
    <>
      <Spin spinning={isLoading} fullscreen />
      <Alert
        message={infoAlertContent}
        type="info"
        showIcon
        closable
        style={{ alignItems: "center", margin: "auto", width: "100%" }}
      />

      <ModalSelectionCompany />
      
      <SurveyModal 
        visible={showSurveyModal} 
        onCancel={handleSurveyModalClose} 
      />

      <div className="info-detail">
        <div className="info-header">
          <h2>Informations Adhérent</h2>
        </div>

        <div className="info-identifiant">
          <div className="col1">
            <InfoRow
              left="Identifiant APAS :"
              right={receivedDataIdentifier || activeCompany?.membershipCode}
              width="150"
              idToTest="membershipCode-infodetail"
            />
            <InfoRow
              left="Raison sociale :"
              right={activeCompany?.companyName}
              width="150"
            />
            <InfoRow left="E-mail :" right={user?.email} width="150" />
          </div>
        </div>

        <div className="info-adherent-effectif">
          <div className="adherent">
            <InfoRow
              left="Adhérent :"
              right={
                activeCompany?.laborUnion === 2
                  ? "CAPEB"
                  : activeCompany?.laborUnion === 3
                  ? "FFB"
                  : "aucun"
              }
            />
          </div>

          <div className="effectif">
            <InfoRow
              left="Effectifs :"
              right={
                activeCompany?.workForce === "moreThan10"
                  ? "Plus de 10 salariés"
                  : activeCompany?.workForce === "upTo10"
                  ? "Jusqu'à 10 salariés"
                  : "Pas de données"
              }
            />
          </div>
          <div className="box-label-input">
            <Checkbox
              disabled
              checked={activeCompany?.buildingConventionOutside77}
              name="buildingConventionOutside77"
              className="checkbox"
            >
              <span style={{ color: "black", fontWeight: "bold" }}>
                Conventions du Bâtiment hors 77
              </span>
            </Checkbox>
          </div>

          {/* Condition: company?.workForce === "moreThan10" && company?.laborUnion !== 2 */}
          {conditionCheckbox && (
            <div className="box-label-input">
              <Checkbox
                disabled
                checked={activeCompany?.agreeOptionalWorker}
                name="agreeOptionalWorker"
                className="checkbox"
              >
                <span style={{ color: "black", fontWeight: "bold" }}>
                  J'ai pris connaissance que la souscription aux Prestations
                  pour les Ouvriers est optionnelle
                </span>
              </Checkbox>
            </div>
          )}
        </div>

        <div className="info-address">
          <div className="info-line">
            <InfoRow left="Adresse :" right={activeCompany?.address2} />
          </div>
          <div className="info-line">
            <InfoRow left="Votre référence (optionnel) :" right={activeCompany?.address4} />
          </div>
          <div className="info-line">
            <InfoRow left="Code postal :" right={activeCompany?.zipcode} />
          </div>
          <div className="info-line">
            <InfoRow left="Ville :" right={activeCompany?.city} />
          </div>
          <div className="info-line">
            <InfoRow left="SIREN :" right={activeCompany?.siren} />
          </div>
        </div>

        <div className="info-referent">
          <h3>Représentant légal ou Référent</h3>

          <div className="info-line">
            <InfoRow
              left="Nom :"
              right={activeCompany?.representativeLastname}
            />
          </div>
          <div className="info-line">
            <InfoRow
             left="Prénom :"
             right={activeCompany?.representativeFirstname}
            />
          </div>
          <div className="info-line">
            <InfoRow
              left="Fonction :"
              right={activeCompany?.representativeFunction}
            />
          </div>
          <div className="info-line">
            <InfoRow left="Tél :" right={activeCompany?.representativePhone} />
          </div>
        </div>

        <div className="block-button">
          <ButtonLink to="/infoIdentifier/infoDetail/update">
            Modifier mes informations
          </ButtonLink>
        </div>
      </div>
    </>
  );
}

export default InfoDetail;
